'use client';
import React, { isValidElement } from 'react';
import { DsmColor } from '../../../../constants/colors.mjs';
import { factory } from '../../../../factory/factory.utils.mjs';
import { Typography } from '../../../../Foundations/Typography/Typography.mjs';
import { Flex } from '../../../../Layout/Flex/Flex.mjs';
import { Box } from '../../../../Other/Box/Box.mjs';
import { omitText } from '../../../../utils/helpers.mjs';
import classes from './AccountCardInformation.module.css.mjs';

const AccountCardInformation = factory((props, ref) => {
  const { title, description, price, slashedPrice, availableColors, brand, ...rest } = props;
  return /* @__PURE__ */ React.createElement(Box, { ref, ...rest, className: classes.accountCardInformation }, /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: 5 }, brand && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: isValidElement(brand.text) ? "div" : brand.component || "p",
      ...omitText(brand),
      size: "label-medium-s",
      textColor: DsmColor.ContentTertiary
    },
    brand.text
  ), title && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: title.component || "span",
      ...omitText(title),
      textColor: DsmColor.ContentSecondary,
      size: "label-regular-l"
    },
    title.text
  ), description && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: isValidElement(description.text) ? "div" : description.component || "p",
      ...omitText(description),
      size: "paragraph-medium",
      textColor: DsmColor.ContentTertiary
    },
    description.text
  ), availableColors && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: isValidElement(availableColors.text) ? "div" : availableColors.component || "p",
      ...omitText(availableColors),
      size: "paragraph-medium",
      paddingTop: 5,
      textColor: DsmColor.ContentTertiary
    },
    availableColors.text
  )), (price || slashedPrice) && /* @__PURE__ */ React.createElement(Flex, { direction: "column" }, price && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: isValidElement(price.text) ? "div" : price.component || "span",
      ...omitText(price),
      textColor: DsmColor.ContentTertiary,
      size: "label-medium-m"
    },
    price.text
  ), slashedPrice && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: isValidElement(slashedPrice.text) ? "div" : slashedPrice.component || "span",
      ...omitText(slashedPrice),
      textColor: DsmColor.ContentSecondary,
      size: "label-regular-m",
      textDecoration: "line-through"
    },
    slashedPrice.text
  )));
});

export { AccountCardInformation };
